var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.5001,
    r: 16,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7977 10.2863C13.1916 9.89921 13.8247 9.9047 14.2119 10.2986L18.9292 15.0985C19.694 15.8767 19.694 17.1242 18.9292 17.9023L14.2119 22.7022C13.8247 23.0961 13.1916 23.1016 12.7977 22.7145C12.4038 22.3274 12.3983 21.6942 12.7854 21.3003L17.5028 16.5004L12.7854 11.7005C12.3983 11.3066 12.4038 10.6735 12.7977 10.2863Z",
    fill: "#6301CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointGo);
export default __webpack_public_path__ + "static/media/pointGo.2aca66289cb0bf642b096cf042b7112f.svg";
export { ForwardRef as ReactComponent };